<template>
  <div class="animated fadeIn">
    <b-list-group v-if="observations.length > 0">
      <b-list-group-item class="d-flex justify-content-between" style="word-break: break-word;" v-for="obs in observations" :key="obs.id">
        {{obs.detalhes}}
        <span class="ml-1">
          <b-badge variant="primary" pill>{{moment(obs.data).format('DD/MM/YY')}}</b-badge>
        </span>
      </b-list-group-item>
    </b-list-group>
    <div v-else>
      Nenhum registro de observação, <strong @click="onAddObs" style="cursor: pointer">clique para adicionar</strong>
    </div>
    <ModalAddObservation ref="ModalAddObservation" v-if="showModal" :card="card" v-on:Reload="onReload"/>
  </div>
</template>

<script>

import CrmDetailsObservation from './observation.js'
export default CrmDetailsObservation

</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/observation/observation.vue